import React, { useEffect } from 'react';
import { SafeHtmlText, toast } from 'shared/components';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { UserSettingsLink } from 'shared/notifications/components/user-settings-link';
import { useSwrPaymentNotifications } from 'shared/notifications/hooks/use-swr-payment-notifications';
export const usePaymentNotification = () => {
  const {
    user,
    isCustomer,
    isWorkspaceOwner
  } = useUser();
  const {
    data: paymentNotifications
  } = useSwrPaymentNotifications();
  const {
    t
  } = useLocoTranslation();
  useEffect(() => {
    if (!isCustomer || !user || !isWorkspaceOwner) return;
    if (!paymentNotifications) return;
    if (paymentNotifications.paymentNotification) {
      toast.info(<SafeHtmlText html={paymentNotifications.paymentNotification} />);
    }
    if (paymentNotifications.shouldFillProfile) {
      toast.info(<TransLoco t={t} i18nKey={'dashboard.notifications.fill_profile'} components={{
        a: <UserSettingsLink />
      }} />);
    }
    // TFunc should not be in dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCustomer, isWorkspaceOwner, paymentNotifications, user]);
};